import { ecboClient, getHeaderLocale } from 'lib/axios'

import type { CountriesResponse } from 'features/country/types/country'

const API_COUNTRIES = '/api/web/countries'

export const fetchCountries = async (locale: string) => {
  const response = await ecboClient.get<CountriesResponse>(API_COUNTRIES, {
    headers: { 'Accept-Language': getHeaderLocale(locale) },
  })
  return {
    isOk: true as const,
    data: response.data,
  }
}
